module.exports = __webpack_public_path__ + "media/application/images/ui/star-4ff40e73cea544949565bfa8bc7ff3cc.png";